// React i hooks
import { memo, useCallback } from "react";

// Helpers
import { transformDateToLocalDateString, transformDateToLocalDateTimeString } from "helpers";

// Tipovi i konstante
import { PublicApiKeyRowProps } from "./types";

// UI komponente
import { Button } from "ui/components/Button/Button";
import Badge from "ui/components/Badge/Badge";

const PublicApiKeyRow: React.FC<PublicApiKeyRowProps> = (props) => {
  const { apiKey, onRotate, onRevoke } = props;

  const handleRotate = useCallback(() => onRotate(apiKey), [apiKey, onRotate]);
  const handleRevoke = useCallback(() => onRevoke(apiKey), [apiKey, onRevoke]);

  const meta: string[] = [`Izdan ${transformDateToLocalDateString(apiKey.created) ?? "—"}`];

  meta.push(
    apiKey.lastUsed
      ? `Zadnja uporaba ${transformDateToLocalDateTimeString(apiKey.lastUsed)}`
      : "Još nije korišten"
  );

  if (apiKey.expiresAt) {
    meta.push(
      `${apiKey.isExpired ? "Istekao" : "Istječe"} ${transformDateToLocalDateString(apiKey.expiresAt)}`
    );
  }

  return (
    <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 px-4 py-3">
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <p className="font-semibold text-slate-800 truncate">{apiKey.name}</p>
          {apiKey.isExpired ? (
            <Badge text="Istekao" variant="danger" height="small" />
          ) : (
            <Badge text="Aktivan" variant="success" height="small" />
          )}
        </div>
        <p className="font-mono text-sm text-slate-600">{apiKey.keyPrefix}…</p>
        <p className="text-xs text-slate-500">{meta.join(" · ")}</p>
      </div>

      <div className="flex gap-2 shrink-0">
        <Button
          variant="outlined"
          size="small"
          startIcon="/media/icons/refresh.svg"
          onClick={handleRotate}
        >
          Rotiraj
        </Button>
        <Button variant="remove" size="small" onClick={handleRevoke}>
          Opozovi
        </Button>
      </div>
    </div>
  );
};

export default memo(PublicApiKeyRow);
